var _desc, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _circle2, _text, _text2, _text3, _text4, _polygon, _polygon2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuStatic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ic\xF4ne boussole \u2014 statique") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Rose des vents avec aiguille Nord/Sud, cercles concentriques et points cardinaux")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 36,
    fill: "none",
    stroke: "#534f4f",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 5,
    x2: 40,
    y2: 11,
    stroke: "#534f4f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 69,
    x2: 40,
    y2: 75,
    stroke: "#534f4f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 40,
    x2: 11,
    y2: 40,
    stroke: "#534f4f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 40,
    x2: 75,
    y2: 40,
    stroke: "#534f4f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 14.5,
    x2: 18.5,
    y2: 18.5,
    stroke: "#534f4f",
    strokeWidth: 1,
    strokeLinecap: "round",
    opacity: 0.45
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 61.5,
    y1: 14.5,
    x2: 57.5,
    y2: 18.5,
    stroke: "#534f4f",
    strokeWidth: 1,
    strokeLinecap: "round",
    opacity: 0.45
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 65.5,
    x2: 18.5,
    y2: 61.5,
    stroke: "#534f4f",
    strokeWidth: 1,
    strokeLinecap: "round",
    opacity: 0.45
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 65.5,
    y1: 65.5,
    x2: 61.5,
    y2: 61.5,
    stroke: "#534f4f",
    strokeWidth: 1,
    strokeLinecap: "round",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 26,
    fill: "none",
    stroke: "#534f4f",
    strokeWidth: 0.6,
    opacity: 0.25
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 9,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 8,
    fontWeight: 700,
    fill: "#534f4f",
    letterSpacing: 0
  }, "N")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 74,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 7,
    fontWeight: 400,
    fill: "#534f4f",
    opacity: 0.55
  }, "S")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 41,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 7,
    fontWeight: 400,
    fill: "#534f4f",
    opacity: 0.55
  }, "E")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 41,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 7,
    fontWeight: 400,
    fill: "#534f4f",
    opacity: 0.55
  }, "O")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "40,16 44,38 40,34 36,38",
    fill: "#534f4f"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "40,64 44,42 40,46 36,42",
    fill: "none",
    stroke: "#534f4f",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 4.5,
    fill: "#ffffff",
    stroke: "#534f4f",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 1.8,
    fill: "#534f4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatic);
export default __webpack_public_path__ + "static/media/menu_static.04031e8add28801a163e1ed0b75d3e1f.svg";
export { ForwardRef as ReactComponent };